// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kAUD","fullView":"styles_fullView__2tuOa"};